import React from 'react'
import { useAsync } from 'react-async'
import slaRepository from '../SlaRepository'
import {
  ResponsiveContainer,
  Tooltip,
  BarChart,
  YAxis,
  Bar,
  XAxis,
  CartesianGrid,
  Legend
} from 'recharts'
import { secondsToStringTimer } from '../../../utils/Formatter'
import { Typography, Paper, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))

const fetchData = async ({ solicitacaoId }) => {
  const response = await slaRepository.logSolicitacaoTempoStatus(solicitacaoId)
  if (!response.ok) throw new Error(response.error)
  return [
    { status: 'Aberto', tempo: response.data.tempoAberto },
    { status: 'Reaberto', tempo: response.data.tempoReaberto },
    { status: 'Análise', tempo: response.data.tempoAnalise },
    { status: 'Reanálise', tempo: response.data.tempoReanalise },
    { status: 'Pendente', tempo: response.data.tempoPendente },
    {
      status: 'Pendente Monitoramento',
      tempo: response.data.tempoPendenteGestor
    }
  ]
}

function CustomizedAxisTick(props) {
  const { x, y, payload } = props

  return (
    <g>
      <text x={x} y={y} dy={4} textAnchor="end" fill="#666666">
        {payload.value}
      </text>
    </g>
  )
}

function ChartTempoStatus(props) {
  const { data } = useAsync({
    promiseFn: fetchData,
    solicitacaoId: props.match.params.id
  })
  const classes = useStyles()
  return (
    <Paper className={classes.root}>
      <Typography variant="h6">Tempo por status</Typography>
      <ResponsiveContainer height={300}>
        <BarChart
          layout="vertical"
          data={data}
          margin={{
            top: 20,
            left: 150
          }}
        >
          <Legend iconType="circle" />
          <CartesianGrid strokeDasharray="3 3" />
          <YAxis
            dataKey="status"
            type="category"
            tick={<CustomizedAxisTick />}
          />
          <Tooltip
            formatter={value => {
              return secondsToStringTimer(value, '')
            }}
          />
          <Bar
            dataKey="tempo"
            name="Tempo por status"
            fill="#e57373"
            maxBarSize={30}
          />
          <XAxis
            type="number"
            tickFormatter={tick => {
              return secondsToStringTimer(tick, '')
            }}
          />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  )
}

export default ChartTempoStatus
